import {Company} from '@peachy/core-domain-pure'
import {Component} from 'solid-js'

export const InfoPanelAddressDetails: Component<{ company: Company }> = (props) => {
    return (
            <p>Address <span>{props.company?.address?.display}</span></p>
    )
}
